export default {
  item:
    '{{label}} ({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})',
  defaultOption: 'See all',
};



// WEBPACK FOOTER //
// ./src/widgets/menu-select/defaultTemplates.js